import React from 'react';
import { WeezHeader, Card, Icon } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import HomeStatistics from './statistics';
import Style from './home.module.css';
import HomeTab from './homeTab';
import SalesReport from '../../../../models/salesReport';
import { useHistory } from 'react-router-dom';
import LoadingCard from '../../../../components/loadingCard';

const Home = ({ organization, ticket_office }) => {
    const { t } = useTranslation();
    const history = useHistory();

    const [data, loadingData] = SalesReport.useApiModel(
        {
            organizationId: organization.id,
            ticket_officeId: ticket_office.id
        },
        [organization, ticket_office]
    );

    const loading = React.useMemo(() => {
        return loadingData || !data;
    }, [loadingData, data]);

    return (
        <>
            <WeezHeader
                title={t('ticket.ticket_office_home.header.name')}
                backLink={{
                    onClick: () => history.push(`/ticket/O${organization.id}/ticket_offices?deleted=0`)
                }}
            />

            <>
                <HomeStatistics organization={organization} ticket_office={ticket_office} data={data} loading={loading} />
                <Card>
                    <Card.Header>
                        <div className={Style['div_header_container']}>
                            <div>
                                <Card.Title title={t('ticket.ticket_office_home.tab_header.title')} />
                                <Card.SubTitle title={t('ticket.ticket_office_home.tab_header.subtitle')} />
                            </div>
                            <div className={Style['div_text_content']}>
                                <span
                                    className={Style['text_to_link']}
                                    onClick={() => history.push(`/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/reports/salesjournal`)}
                                >
                                    <Icon name="chart" />
                                    {t('ticket.ticket_office_home.see_all')}
                                </span>
                            </div>
                        </div>
                    </Card.Header>
                    <LoadingCard loading={loading}>
                        <HomeTab currency={organization.currency} locale={organization.default_locale} data={data?.events} />
                    </LoadingCard>
                </Card>
            </>
        </>
    );
};

export default Home;
